import React from 'react';
import { styled } from '@compiled/react';
import { lazy } from 'react-loosely-lazy';
import { token } from '@atlaskit/tokens';
import { SOFTWARE_DEPLOYMENTS_ISSUE } from '@atlassian/jira-common-constants/src/analytics-sources';
import Placeholder from '@atlassian/jira-placeholder';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const IssueApp = lazy(
	() =>
		import(
			/* webpackChunkName: "async-issue-app" */ '@atlassian/jira-issue-view/src/views/issue-details/issue-app'
		),
);

type Props = {
	issueKey: IssueKey;
	onClose: () => void;
};

const Issue = ({ issueKey, onClose }: Props) => (
	<ContextualAnalyticsData sourceType={SCREEN} sourceName="deploymentsIssue">
		<DetailsWrapper>
			<Placeholder name="issue-app" fallback={null}>
				<IssueApp
					viewModeOptions={{ viewMode: 'SIDEBAR' }}
					issueKey={issueKey}
					analyticsSource={SOFTWARE_DEPLOYMENTS_ISSUE}
					shouldSetInitialFocus
					shouldShowCloseButton
					onClose={onClose}
					isLoadedWithPage={false}
					isSpaEnabled={false}
				/>
			</Placeholder>
		</DetailsWrapper>
	</ContextualAnalyticsData>
);

export default Issue;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DetailsWrapper = styled.div({
	height: '100%',
	overflowX: 'hidden',
	marginTop: token('space.200', '16px'),
});
